import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { Box, Alert, Icon } from 'shared/ui'
import { Label } from 'shared/ui/Label'
import { makeTextFieldClear, TextField } from 'shared/ui/TextField'
import { LINK_TWILIO_GUIDE } from 'shared/constants/links'
import { InputPassword } from 'shared/ui/TextField/InputPresets/InputPassword'
import { type ConnectTwilioModalStore } from 'entities/Phone/ui/ConnectTwilioModal'

import styles from './styles.module.scss'

type IConnectTwilioModalContentProps = {
  store: ConnectTwilioModalStore
}

export const ConnectTwilioModalContent: FC<IConnectTwilioModalContentProps> = observer(
  ({ store }) => {
    const { setAccountSid, setAuthToken, loading, authToken, accountSid, error, isPrefilled } =
      store

    return (
      <div>
        <Box display={'grid'} gap={'8px'} marginBottom={'24px'}>
          <Alert
            item={{
              type: 'infoBlue',
              desc: 'Find your account SID and auth token in the Twilio Admin Console',
            }}
            rightActions={[
              {
                variant: 'link',
                type: 'primary',
                text: 'Learn more',
                link: LINK_TWILIO_GUIDE,
              },
            ]}
          />
          {error && (
            <Alert
              item={{
                type: 'error',
                title: error,
              }}
            />
          )}
        </Box>
        <Box display={'grid'} gap={'16px'}>
          <div className={styles.iconWrapper}>
            <Icon icon='twilioIntegration' fontSize={200} />
          </div>

          <Box display={'grid'} gap={'4px'}>
            <Label
              label={{
                text: 'Twilio account SID',
              }}
            />
            <TextField
              Input={InputPassword}
              variant={'stroke'}
              size={'small'}
              className={styles.textField}
              viewOnly={isPrefilled}
              InputProps={{
                placeholder: 'XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX',
              }}
              value={accountSid}
              disabled={loading || isPrefilled}
              onChange={setAccountSid}
              rightActions={[makeTextFieldClear()]}
            />
          </Box>

          <Box display={'grid'} gap={'4px'}>
            <Label
              label={{
                text: 'Twilio auth token',
              }}
            />
            <TextField
              Input={InputPassword}
              variant={'stroke'}
              size={'small'}
              className={styles.textField}
              InputProps={{
                placeholder: 'XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX',
              }}
              value={authToken}
              disabled={loading}
              onChange={setAuthToken}
              rightActions={[makeTextFieldClear()]}
            />
          </Box>
        </Box>
      </div>
    )
  }
)
